import * as yup from 'yup';

export const antiquity = yup.object().shape({
  type: yup.number().required('Este campo es obligatorio'),
  years: yup.number().when('type', {
    is: 2,
    then: yup
      .number()
      .required('Este campo es obligatorio')
      .typeError('Número inválido')
      .positive('El número debe ser mayor a 0')
  })
});
